import { Input, OnInit, Directive } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { Patch, BaseHttpService, UriBuilderParams } from '@app/core/services/base/base-http.service';
import { BaseWithId } from '@app/shared/models/base';
import * as _ from 'lodash-es';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { BaseChangeComponent } from '@app/shared/components/base/base-change.component';

export interface PatchValue {
  propertyName: string;
  value: any;
}

@Directive()
export abstract class BasePatchComponent<T extends BaseWithId, U extends UriBuilderParams<T>> extends BaseChangeComponent<T, U>
                                                                                              implements OnInit {
  @Input()
  private patchPrefix: string;

  protected constructor(protected componentServiceBundle: ComponentServiceBundle,
                        protected drHttpService: BaseHttpService<T, U> & Patch<T, U>) {
    super(componentServiceBundle, drHttpService);
  }

  public ngOnInit() {
      super.ngOnInit();
  }

  public patchAndUpdate(propName: string, callbackFn?: Function): void {
    const updatedValue = _.get(this.updated, propName);
    this.patchAndUpdateWithValue({propertyName: propName, value: updatedValue}, callbackFn);
  }

  public patchAndUpdateWithValue(patchValue: PatchValue, callbackFn?: Function): void {
    const origValue = _.get(this.original, patchValue.propertyName);

    if (origValue !== patchValue.value) {
      const patchDataArray = new Array<OpData>();
      patchDataArray.push({
        op: OP.replace,
        path: this.convertToPatchPath(patchValue.propertyName),
        value: patchValue.value
      });

      this.patchOpDataArray(patchDataArray, callbackFn);
    }
  }

  public patchOpDataArray(patchDataArray: OpData[], callbackFn?: Function): void {
    const uriParams = this.generateUriBuilderParams();
    this.drHttpService.patchAndUpdate(uriParams, this.original, patchDataArray, this.patchParams)
        .subscribe((result: T) => {
                this.afterChange(result, callbackFn);
            }, err => this.handleError(err)
        );
  }

  protected convertToPatchPath(objectPath: string): string {
    if (objectPath) {
      const prefix = this.patchPrefix ? `${this.patchPrefix}/` : '';
      // Replace all . by /
      const converted = objectPath.replace(/\./g, '/');
      return prefix + converted;
    }
    return '';
  }

}
